/* eslint-disable @typescript-eslint/naming-convention, no-magic-numbers, id-denylist -- Established notification enum values (including the restricted `info` member); renaming would break consumers. */
export var NotificationDurationMs;
(function (NotificationDurationMs) {
    NotificationDurationMs[NotificationDurationMs["short"] = 2000] = "short";
    NotificationDurationMs[NotificationDurationMs["normal"] = 3000] = "normal";
    NotificationDurationMs[NotificationDurationMs["long"] = 5000] = "long";
    NotificationDurationMs[NotificationDurationMs["inifinite"] = 0] = "inifinite";
})(NotificationDurationMs || (NotificationDurationMs = {}));
export var NotificationType;
(function (NotificationType) {
    NotificationType["success"] = "success";
    NotificationType["error"] = "error";
    NotificationType["warning"] = "warning";
    NotificationType["alert"] = "alert";
    NotificationType["info"] = "info";
    NotificationType["default"] = "default";
})(NotificationType || (NotificationType = {}));
